export { default as ProductionCostClosingSlot } from './ProductionCostClosingSlot';
